module.exports = __webpack_public_path__ + "img/ltkhome-4x.4f8c4b8.jpg";